import { useEffect, useState } from "react";
import Table from "../../components/common/table/Table";
import Title from "../../components/common/title/Title";
import { getApi } from "../../services/api/globalApi";
import Pagination from "../../components/common/pagination/Pagination";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { utilsState } from "../../sotre/redux/features/utilsSlice";
import { learnListColumns } from "../../constant/tablesColumns/tablesColums";

export default function LearnList() {
  const [userData, setUserData] = useState([]);
  const [pagination, setPagination] = useState(null);

  const { utils } = useSelector(utilsState);

  const getUser = async (params) => {
    const path = "admin/learns";
    try {
      const response = await getApi({ path, params: { ...params } });
      setUserData(response?.data?.result.data);
      setPagination(response?.data?.result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUser({});
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    console.log("filter", allFilter);
    getUser(allFilter);
  };

  const data = [];

  userData?.map((item) =>
    data.push({
      ...item,
      key: item._id,
      id: item._id,
      faStatus:
        (item.status === "active"
          ? "فعال"
          : item.status === "pending"
          ? "انتظار"
          : "غیرفعال") || "pending",
      status: item.status,
    })
  );

  console.log(data);

  const navigate = useNavigate();

  const editLearn = (singleLearn) => {
    navigate("/edit-learn", { state: singleLearn });
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <Title title={"لیست آموزش ها"} />

      <Pagination
        pagination={pagination}
        filterDataHandler={filterDataHandler}
      />
      <Table columns={learnListColumns} rows={data} onEdit={editLearn} />

      <Pagination
        pagination={pagination}
        filterDataHandler={filterDataHandler}
      />
    </div>
  );
}
